import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({name: 'lastVersion'})
export class LastVersionPipe implements PipeTransform {
  transform(value: string): string {
    const versions = value.split(',');
    return versions[versions.length-1];
  }
}
